import { makeEnum } from './constantsUtils';

export const STORE_NAMES = makeEnum(
  'rootStore',
  'uiStore',
  'ratingStore',
  'geoStore',
  'featureStore',
  'bannerStore',
);
